'use client';

import React from 'react';

interface SignalGroupHeaderProps {
  label: string;
  matchedCount?: number;
  totalCount: number;
}

const SignalGroupHeader: React.FC<SignalGroupHeaderProps> = ({
  label,
  matchedCount,
  totalCount,
}) => (
  <div
    role="heading"
    aria-level={4}
    aria-label={
      matchedCount != null
        ? `${label}: ${matchedCount} of ${totalCount} matched`
        : `${label}: ${totalCount} criteria`
    }
    className="flex items-center justify-between gap-2 px-4 py-2 bg-neutral-50 border-y border-neutral-100"
    data-testid={`signal-group-header-${label.toLowerCase().replace(/\s+/g, '_')}`}
  >
    <span className="text-xs font-semibold text-neutral-700">
      {label}
    </span>
    <span
      className="text-xs font-medium text-neutral-400"
      data-testid={`signal-group-match-count-${label.toLowerCase().replace(/\s+/g, '_')}`}
    >
      {matchedCount != null
        ? `${matchedCount}/${totalCount} matched`
        : `${totalCount} criteria`}
    </span>
  </div>
);

export default SignalGroupHeader;
